import { css } from '@emotion/react';
import { Chip, NakedButton, Text, useTooltip } from '@frontend/design-system';
import { useSchedulingLocationInfo } from '../../../../hooks';
import { useCalendarLocationIds, useCalendarStore } from '../../../../stores';
import { CALENDAR_TRACKING_IDS } from '../../../../trackingIds/calendar-tracking-ids';

export const LocationChip = () => {
  const { selectedLocationIds, getScopeName } = useSchedulingLocationInfo();
  const { Tooltip, tooltipProps, triggerProps: tooltipTriggerProps } = useTooltip();
  const { setShowLocationSelectorModal } = useCalendarStore(['setShowLocationSelectorModal']);
  const { calendarLocationIds } = useCalendarLocationIds();
  const calendarLocationCount = calendarLocationIds.length;

  const showLocationSelectorModal = () => {
    setShowLocationSelectorModal(true);
  };

  if (selectedLocationIds.length <= 1) return null;

  if (calendarLocationCount === 1) {
    return (
      <Chip.SingleChip
        css={chipStyle}
        trackingId={CALENDAR_TRACKING_IDS.headerBar.locationChip}
        onClick={showLocationSelectorModal}
        tooltipLabel={getScopeName(calendarLocationIds[0])}
      >
        1
      </Chip.SingleChip>
    );
  }

  return (
    <>
      <NakedButton
        onClick={showLocationSelectorModal}
        {...tooltipTriggerProps}
        trackingId={CALENDAR_TRACKING_IDS.headerBar.locationChip}
      >
        <Chip.MultiChip css={chipStyle} hideTooltip>
          {calendarLocationCount}
        </Chip.MultiChip>
      </NakedButton>
      <Tooltip {...tooltipProps}>
        {calendarLocationIds.map((locationId) => (
          <Text key={locationId} size='medium' color='white'>
            {getScopeName(locationId)}
          </Text>
        ))}
      </Tooltip>
    </>
  );
};

const chipStyle = css({
  width: 'fit-content',
  maxWidth: 'unset',
  cursor: 'pointer',
});
